import version from "build.json";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";

import { ImageStyled, LogoContainer, LogoLink, VersionLink } from "./styles";

export const Logo = () => {
    const router = useRouter();
    const isHomePage = router.pathname === "/";

    return (
        <LogoContainer>
            <Link href="/" passHref>
                <LogoLink title="Talkuccino Home Page">
                    <ImageStyled src={"/images/logo.png"} alt="Talkuccino Logo" />
                </LogoLink>
            </Link>
            {!isHomePage && <VersionLink>{version.version}</VersionLink>}
        </LogoContainer>
    );
};
